import React, { FC } from 'react';
import type { PaymentOrchestrationTransactionMonitoringProps } from '@/types';
import { Image } from '../image';
import { TextCols } from '../text-cols';

export const PaymentOrchestrationTransactionMonitoring: FC<
  PaymentOrchestrationTransactionMonitoringProps
> = ({ content, cover }) => {
  return (
    <section className="paymentOrchestrationTransactionMonitoring">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={786} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="paymentOrchestrationTransactionMonitoring--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
